<template>
  <div>
    <div class="home-banner"
         v-if="banners.length>1">
      <swiper :options="swiperOption"
              ref="mySwiper">
        <swiper-slide v-for="(item,i) in banners"
                      :key="i">
          <div class="box">
            <h1 class="title">{{item.info}}</h1>
            <div class="banner_box"
                 style="text-align:center;">
              <img :src='item.picHrefUrl'
                   :srcset="item.picUrl" />
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-bullets"
             slot="pagination"></div>
      </swiper>
    </div>
    <div class="home-banner"
         v-if="banners.length==1">
      <div v-for="(item,i) in banners"
           :key="i">
        <img :src='item.picUrl'
             @click="bannerNext(0)" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      banners: [
        {
          "picUrl": require("../assets/img/vip/handle_banner1.png"),
          "picHrefUrl": "www.baidu.com",
          "id": 1,
          "info": "会员尊享5大特权"
        },
        {
          "picUrl": require("../assets/img/vip/handle_banner2.png"),
          "picHrefUrl": "www.taobao.com",
          "id": 2,
          "info": "为什么开通会员"
        },
      ],
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        autoplayDisableOnInteraction: false,
        initialSlide: 0,
        grabCursor: true,
        loop: true,
        // observer:true,
        // observeParents:true,
        pagination: {
          el: '.swiper-pagination',
          bulletActiveClass: 'swiper-pagination-bullets-active'
        },
        // on: {
        //   click: function (e) {
        //     if (e.target.className == '') {
        //       let url = e.target.src
        //       window.location.href = url
        //     }
        //   }
        // }

      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper && this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    // this.getbanner()

  },
  methods: {
    bannerNext (i) {
      let item = this.banners[i]
      window.location.href = item.picHrefUrl
    },
    getbanner () {
      this.$get('/user/banner/queryBanner.do', {
        deviceType: 1
      }).then((res) => {
        if (res.code == 200) {
          this.banners = res.data

          if (res.data.length > 1) {
            if (this.swiper) {
              this.swiper.slideTo(1, 0, false)
              this.swiper.autoplay.stop()
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
.home-banner {
  width: 93%;
  margin: 0 auto;
  position: relative;
  margin-bottom: 0.1rem;
  height: 2.54rem;
  position: relative;
  top: -0.13rem;
  background: linear-gradient(
    315deg,
    rgba(212, 177, 145, 1) 0%,
    rgba(253, 230, 204, 1) 50%,
    rgba(227, 204, 170, 1) 100%
  );
  -webkit-overflow-scrolling: touch;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding-top: 0.13rem;
  .title {
    font-size: 0.14rem;
    background: linear-gradient(
      180deg,
      rgba(62, 51, 39, 1) 0%,
      rgba(94, 81, 67, 1) 100%
    );
    border-radius: 0px 100px 100px 0px;
    border-top-right-radius: 14px;
    color: #ffffff;
    border-bottom-right-radius: 14px;
    padding: 0.02rem 0 0.02rem 0.15rem;
    width: 1.45rem;
    margin-bottom: 0.2rem;
  }
  .banner_box {
    margin-bottom: 0.3rem;
    width: 2.95rem;
    margin: 0 auto;
  }
  img {
    display: block;
    width: 100%;
    height: 1.55rem;
    margin: 0 auto;
  }
}
.swiper-wrapper {
  padding-bottom: 0.25rem;
}
.swiper-pagination.swiper-pagination-bullets {
  bottom: 0;
}
.swiper-pagination .swiper-pagination-bullet {
  width: 0.06rem;
  height: 0.06rem;
  background: #fff;
  opacity: 1;
}
.swiper-pagination .swiper-pagination-bullets-active {
  background: #333;
  opacity: 1;
}
</style>
